import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";

import { NotifyContext } from "./../../../util/notify";
import api from "./../../../services/api";
import upload from "./../../../services/s3";
import File from "./../../../components/Form/File";

import {
  Container,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  ActionButton,
  Modal,
  ModalContent,
  Form,
  FormGroup,
  Label,
  Input,
  ButtonGroup,
  Content,
  TableBody,
  AddButton,
  HelperText,
} from "./../Subscribers/styles";

const client_id = process.env.REACT_APP_CLIENT_ID;
const site_id = process.env.REACT_APP_SITE_ID;

const emptyForm = {
  id: null,
  name: "",
  education: "",
  curriculum: "",
  position: 0,
  image_path: "",
  is_active: true,
};

export default function Speakers({ toggleTitles }) {
  const { course_id } = useParams();
  const { notify } = useContext(NotifyContext);

  const [speakers, setSpeakers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);

  async function loadData() {
    notify.show(true, "Carregando", "info");
    try {
      const [{ data: course }, { data: list }] = await Promise.all([
        api.get(`/courses/${course_id}`),
        api.get(`/courses/${course_id}/speakers`),
      ]);

      setSpeakers(Array.isArray(list) ? list : list.data || []);
      toggleTitles("Cursos", `Palestrantes - ${course.name || ""}`);
    } catch (error) {
      console.log(error);
      notify.show(true, "Erro ao carregar palestrantes", "error");
    }
    notify.show(false, "Carregando", "info");
  }

  useEffect(() => {
    loadData();
  }, []);

  const openCreate = () => {
    setForm({ ...emptyForm, position: speakers.length });
    setImages([]);
    setShowModal(true);
  };

  const openEdit = speaker => {
    setForm({
      id: speaker.id,
      name: speaker.name || "",
      education: speaker.education || "",
      curriculum: speaker.curriculum || "",
      position: speaker.position != null ? speaker.position : 0,
      image_path: speaker.image_path || "",
      is_active: speaker.is_active !== false,
    });
    setImages(speaker.image_path ? [{ file: speaker.image_path }] : []);
    setShowModal(true);
  };

  const handleSave = async e => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!form.name.trim()) {
        notify.show(true, "Nome é obrigatório", "error");
        setLoading(false);
        return;
      }

      let image_path = form.image_path || null;

      if (images.length > 0) {
        notify.show(true, "Enviando foto...", "info");
        const uploaded = await upload(client_id, site_id, images, "cursos/palestrantes/");
        if (uploaded && uploaded[0] && uploaded[0].fileUrl) {
          image_path = uploaded[0].fileUrl;
        } else if (uploaded && uploaded[0] && !uploaded[0].fileUrl && form.image_path) {
          image_path = form.image_path;
        } else if (!form.image_path) {
          // foto opcional
        }
      }

      const payload = {
        name: form.name.trim(),
        education: form.education || null,
        curriculum: form.curriculum || null,
        position: Number(form.position) || 0,
        image_path: image_path || null,
        is_active: !!form.is_active,
      };

      if (form.id) {
        await api.put(`/course_speakers/${form.id}`, payload);
        notify.show(true, "Palestrante atualizado", "success");
      } else {
        await api.post(`/courses/${course_id}/speakers`, payload);
        notify.show(true, "Palestrante adicionado", "success");
      }

      setShowModal(false);
      setForm(emptyForm);
      setImages([]);
      loadData();
    } catch (error) {
      console.log(error);
      notify.show(true, "Erro ao salvar palestrante", "error");
    }

    setLoading(false);
  };

  const handleDeactivate = async speaker => {
    if (!window.confirm(`Desativar o palestrante "${speaker.name}"?`)) return;

    try {
      await api.delete(`/course_speakers/${speaker.id}`);
      notify.show(true, "Palestrante desativado", "success");
      loadData();
    } catch (error) {
      console.log(error);
      notify.show(true, "Erro ao desativar palestrante", "error");
    }
  };

  return (
    <>
      <Container>
        <Content>
          <AddButton type="button" onClick={openCreate}>
            + Adicionar palestrante
          </AddButton>

          {speakers.length === 0 && (
            <div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
              Nenhum palestrante cadastrado para este curso
            </div>
          )}

          {speakers.length > 0 && (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableCell>Foto</TableCell>
                  <TableCell>Nome</TableCell>
                  <TableCell>Formação</TableCell>
                  <TableCell>Ordem</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Ações</TableCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {speakers.map(speaker => (
                  <TableRow key={speaker.id}>
                    <TableCell>
                      {speaker.image_path ? (
                        <img
                          src={speaker.image_path}
                          alt={speaker.name}
                          style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 4 }}
                        />
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell>{speaker.name}</TableCell>
                    <TableCell>{speaker.education || "-"}</TableCell>
                    <TableCell>{speaker.position}</TableCell>
                    <TableCell>
                      <span style={{ color: speaker.is_active ? "green" : "red", fontWeight: "bold", fontSize: 12 }}>
                        {speaker.is_active ? "ATIVO" : "INATIVO"}
                      </span>
                    </TableCell>
                    <TableCell>
                      <div style={{ display: "flex", gap: 8 }}>
                        <ActionButton type="button" onClick={() => openEdit(speaker)} title="Editar">
                          ✎
                        </ActionButton>
                        {speaker.is_active && (
                          <ActionButton type="button" onClick={() => handleDeactivate(speaker)} title="Desativar">
                            ✕
                          </ActionButton>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Content>
      </Container>

      {showModal && (
        <Modal>
          <ModalContent>
            <h2>{form.id ? "Editar palestrante" : "Novo palestrante"}</h2>
            <Form onSubmit={handleSave}>
              <FormGroup>
                <Label>Nome:</Label>
                <Input
                  value={form.name}
                  onChange={e => setForm(prev => ({ ...prev, name: e.target.value }))}
                  required
                />
              </FormGroup>

              <FormGroup>
                <Label>Formação:</Label>
                <Input
                  value={form.education}
                  onChange={e => setForm(prev => ({ ...prev, education: e.target.value }))}
                  placeholder="Ex.: Cirurgião-Dentista, Mestre em Periodontia"
                />
              </FormGroup>

              <FormGroup>
                <Label>Mini currículo:</Label>
                <textarea
                  value={form.curriculum}
                  onChange={e => setForm(prev => ({ ...prev, curriculum: e.target.value }))}
                  rows={5}
                  style={{
                    padding: 10,
                    border: "1px solid #ddd",
                    borderRadius: 4,
                    fontSize: 14,
                    fontFamily: "inherit",
                    resize: "vertical",
                  }}
                />
              </FormGroup>

              <FormGroup>
                <Label>Ordem de exibição:</Label>
                <Input
                  type="number"
                  value={form.position}
                  onChange={e => setForm(prev => ({ ...prev, position: e.target.value }))}
                />
              </FormGroup>

              <FormGroup>
                <Label>Foto:</Label>
                <File
                  id="speaker_image"
                  label=""
                  initialFile={form.image_path || ""}
                  onChange={files => setImages(files)}
                />
                <HelperText>Foto opcional (JPG/PNG).</HelperText>
              </FormGroup>

              <FormGroup>
                <Label>
                  <input
                    type="checkbox"
                    checked={form.is_active}
                    onChange={e => setForm(prev => ({ ...prev, is_active: e.target.checked }))}
                    style={{ marginRight: 8 }}
                  />
                  Ativo
                </Label>
              </FormGroup>

              <ButtonGroup>
                <button type="button" onClick={() => setShowModal(false)}>
                  Cancelar
                </button>
                <button type="submit" disabled={loading}>
                  {loading ? "Salvando..." : "Salvar"}
                </button>
              </ButtonGroup>
            </Form>
          </ModalContent>
        </Modal>
      )}
    </>
  );
}
